module.exports = __webpack_public_path__ + "img/icon_worker.8da7b469.png";